/* eslint-disable */
import irelandApi from '../irelandApi';

export const getEnvironmentVariable = name => (dispatch) => {
  dispatch({type: 'GET_ENVIRONMENT_VARIABLE_PENDING'});

  return irelandApi
    .get(`/api/environment_variables/${name}`)
    .then((response) => {
      dispatch({type: 'GET_ENVIRONMENT_VARIABLE_FULFILLED', payload: response.data.value});
    })
    .catch((error) => {
      dispatch({type: 'GET_ENVIRONMENT_VARIABLE_REJECTED', payload: error});
    });
};
